import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Role } from '@/types/role'

export function createRole(body: Role): Promise<AxiosResponse<Role>> {
  return instance.post(`/iam/role`, body)
}
